const counties = [
  { text: "Adams County", link: "/window-well-covers-adams-county/" },
  { text: "Jefferson County", link: "/window-well-covers-jefferson-county/" },
  { text: "Arapahoe County", link: "/window-well-covers-arapahoe-county/" },
  { text: "El Paso County", link: "/window-well-covers-el-paso-county/" },
  { text: "Denver County", link: "/window-well-covers-denver-q/" },
];

export default counties;
